var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.tipos,"item-text":"value","item-value":"key","label":_vm.label,"rules":_vm.rules,"value":_vm.value},on:{"input":_vm.emitirInput}})}
var staticRenderFns = []

export { render, staticRenderFns }